import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PawPrint, X } from "lucide-react";
import { useLang } from "../i18n";

const VISITS_KEY = "mdc-visits";

const WelcomeBack = () => {
    const { t } = useLang();
    const [show, setShow] = useState(false);

    useEffect(() => {
        const visits = parseInt(localStorage.getItem(VISITS_KEY) || "0", 10);
        localStorage.setItem(VISITS_KEY, String(visits + 1));
        // Saludamos solo a quien vuelve y ya respondió al aviso de cookies (evita solaparse)
        if (visits >= 1 && localStorage.getItem("mdc-cookie-consent")) {
            const timer = setTimeout(() => setShow(true), 2200);
            return () => clearTimeout(timer);
        }
    }, []);

    useEffect(() => {
        if (!show) return undefined;
        const timer = setTimeout(() => setShow(false), 8000);
        return () => clearTimeout(timer);
    }, [show]);

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    data-testid="welcome-back"
                    initial={{ opacity: 0, y: 24, scale: 0.96 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: 24, scale: 0.96 }}
                    transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                    className="fixed bottom-4 left-4 right-4 z-[65] sm:right-auto sm:max-w-sm"
                    role="status"
                >
                    <div className="flex items-start gap-3 rounded-[1.5rem] border border-[#E3DCCF] bg-white/95 p-4 pr-11 shadow-2xl shadow-ink/15 backdrop-blur">
                        <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-olive-light text-olive-dark">
                            <PawPrint size={17} />
                        </span>
                        <div>
                            <p className="font-serif text-base font-semibold italic text-ink">{t.welcome.title}</p>
                            <p className="mt-1 text-[13px] leading-relaxed text-[#525B53]">{t.welcome.text}</p>
                        </div>
                        <button
                            data-testid="welcome-back-close"
                            onClick={() => setShow(false)}
                            aria-label={t.welcome.close}
                            className="absolute right-3 top-3 rounded-full p-1 text-[#7C877E] transition-colors hover:bg-sand/60 hover:text-ink"
                        >
                            <X size={14} />
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default WelcomeBack;
